// Module
var code = `<bds-paper class="action-card"> <div class="action-card__icon"> <bds-icon ng-attr-name="{{\$ctrl.icon}}" size="x-large"></bds-icon> </div> <div> <bds-typo variant="fs-16" bold="bold" translate="{{\$ctrl.label}}"></bds-typo> <bds-typo margin="false" translate="{{\$ctrl.text}}"></bds-typo> </div> </bds-paper>`;
// Exports
module.exports = code;